module.exports = __webpack_public_path__ + "media/icons/country-e90c9e26.svg";